import AcxessException from './acxessException';

export default class ExceptionInvalidToken extends AcxessException {}
